/* ============================================
   Block : Dossier · Où pêcher — carte monde déplaçable + pins
   - Crée un pin par zone rendue (block _fish-dossier-zone, data-x / data-y en % de la carte)
     et le synchronise avec l'accordéon <details> de la liste.
   - Déplacement de la carte : glisser (souris / tactile) et flèches du clavier.
   - La carte se recentre sur la zone ouverte.
   Sans JS, la liste reste utilisable et la carte est centrée sur l'Europe (CSS).
   ============================================ */

(function () {
  'use strict';

  var DRAG_THRESHOLD = 5; // px avant qu'un appui devienne un glisser (sinon : clic sur un pin)
  var KEY_STEP = 80;      // px par appui sur une flèche
  var FALLBACK_CENTER = { x: 51, y: 27 }; // Europe, en % de la carte

  function initZones(root) {
    if (root.hasAttribute('data-fdos-zones-init')) return;
    root.setAttribute('data-fdos-zones-init', '');

    var viewport = root.querySelector('[data-fdos-zones-viewport]');
    var canvas = root.querySelector('[data-fdos-zones-canvas]');
    var hint = root.querySelector('[data-fdos-zones-hint]');
    var zones = Array.prototype.slice.call(root.querySelectorAll('[data-fdos-zone]'));
    if (!viewport || !canvas) return;

    var pos = { x: 0, y: 0 };

    // Le positionnement CSS de repli (left/top 50 % + translate %) est remplacé par un transform en px
    canvas.style.left = '0';
    canvas.style.top = '0';

    function clamp(x, y) {
      var minX = Math.min(0, viewport.clientWidth - canvas.offsetWidth);
      var minY = Math.min(0, viewport.clientHeight - canvas.offsetHeight);
      return {
        x: Math.max(minX, Math.min(0, x)),
        y: Math.max(minY, Math.min(0, y))
      };
    }

    function moveTo(x, y, animate) {
      pos = clamp(x, y);
      canvas.classList.toggle('is-animated', !!animate);
      canvas.style.transform = 'translate(' + pos.x + 'px, ' + pos.y + 'px)';
    }

    function centerOn(xPct, yPct, animate) {
      moveTo(
        viewport.clientWidth / 2 - (xPct / 100) * canvas.offsetWidth,
        viewport.clientHeight / 2 - (yPct / 100) * canvas.offsetHeight,
        animate
      );
    }

    function hideHint() {
      if (hint) hint.classList.add('is-hidden');
    }

    /* --- Pins --- */

    var entries = zones.map(function (zone) {
      var details = zone.querySelector('details');
      var entry = { details: details, pin: null, x: parseFloat(zone.getAttribute('data-x')), y: parseFloat(zone.getAttribute('data-y')) };

      if (!isNaN(entry.x) && !isNaN(entry.y)) {
        var name = zone.getAttribute('data-name');
        var pin = document.createElement('button');
        pin.type = 'button';
        pin.className = 'fdos-zones__pin';
        pin.style.left = entry.x + '%';
        pin.style.top = entry.y + '%';
        pin.setAttribute('aria-label', name + ' : ' + zone.getAttribute('data-label'));

        var count = document.createElement('span');
        count.className = 'fdos-zones__pin-count';
        count.setAttribute('aria-hidden', 'true');
        count.textContent = zone.getAttribute('data-count');

        var label = document.createElement('span');
        label.className = 'fdos-zones__pin-name';
        label.setAttribute('aria-hidden', 'true');
        label.textContent = name;

        pin.appendChild(count);
        pin.appendChild(label);
        canvas.appendChild(pin);

        pin.addEventListener('click', function (event) {
          // Un glisser qui se termine sur un pin ne doit pas l'activer
          if (dragged) {
            event.preventDefault();
            return;
          }
          details.open = true;
        });

        entry.pin = pin;
      }

      details.addEventListener('toggle', function () {
        if (details.open && entry.pin) centerOn(entry.x, entry.y, true);
        sync();
      });

      return entry;
    });

    function sync() {
      entries.forEach(function (entry) {
        if (!entry.pin) return;
        var active = entry.details.open;
        entry.pin.classList.toggle('is-active', active);
        entry.pin.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    }

    /* --- Glisser --- */

    var start = null;
    var dragged = false;

    viewport.addEventListener('pointerdown', function (event) {
      if (event.button !== 0) return;
      start = { px: event.clientX, py: event.clientY, x: pos.x, y: pos.y, id: event.pointerId };
      dragged = false;
    });

    viewport.addEventListener('pointermove', function (event) {
      if (!start || event.pointerId !== start.id) return;
      var dx = event.clientX - start.px;
      var dy = event.clientY - start.py;

      if (!dragged) {
        if (Math.abs(dx) < DRAG_THRESHOLD && Math.abs(dy) < DRAG_THRESHOLD) return;
        dragged = true;
        viewport.setPointerCapture(event.pointerId);
        viewport.classList.add('is-dragging');
        hideHint();
      }

      moveTo(start.x + dx, start.y + dy, false);
    });

    function endDrag(event) {
      if (!start || event.pointerId !== start.id) return;
      start = null;
      viewport.classList.remove('is-dragging');
      if (viewport.hasPointerCapture(event.pointerId)) viewport.releasePointerCapture(event.pointerId);
      // `dragged` reste vrai jusqu'au clic synthétique qui suit, puis est remis à zéro
      setTimeout(function () { dragged = false; }, 0);
    }

    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    /* --- Clavier --- */

    viewport.addEventListener('keydown', function (event) {
      if (event.target !== viewport) return;
      var moves = { ArrowLeft: [KEY_STEP, 0], ArrowRight: [-KEY_STEP, 0], ArrowUp: [0, KEY_STEP], ArrowDown: [0, -KEY_STEP] };
      var move = moves[event.key];
      if (!move) return;
      event.preventDefault();
      hideHint();
      moveTo(pos.x + move[0], pos.y + move[1], true);
    });

    // Un pin qui prend le focus au clavier est ramené dans la fenêtre
    canvas.addEventListener('focusin', function (event) {
      // Le navigateur peut faire défiler la fenêtre (overflow: hidden) pour montrer l'élément focalisé :
      // on annule ce défilement, le déplacement passe uniquement par le transform.
      viewport.scrollLeft = 0;
      viewport.scrollTop = 0;
      var entry = entries.filter(function (e) { return e.pin === event.target; })[0];
      if (entry) centerOn(entry.x, entry.y, true);
    });

    /* --- Position initiale et redimensionnement --- */

    function initialCenter() {
      var open = entries.filter(function (e) { return e.pin && e.details.open; })[0];
      if (open) centerOn(open.x, open.y, false);
      else centerOn(FALLBACK_CENTER.x, FALLBACK_CENTER.y, false);
    }

    initialCenter();
    sync();
    if (hint) hint.hidden = false;

    if ('ResizeObserver' in window) {
      new ResizeObserver(function () { moveTo(pos.x, pos.y, false); }).observe(viewport);
    }
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-fdos-zones]'), initZones);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Éditeur de thème : re-rendu de la section, sélection d'une zone
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var zone = event.target.closest && event.target.closest('[data-fdos-zone]');
    var details = zone && zone.querySelector('details');
    if (details) details.open = true;
  });
})();
